// The Pulse anomaly callout (docs/phase-0/slice6-component-designs.md §4.1
// `AnomalyCallout`; UX §4.2). Renders ONE fired `AnomalySignal`'s own `summary` plainly -
// never a decorative "insight" this component invents. Always the calm `warn` tone,
// never `risk`: `AnomalySignal` (packages/shared/src/model/pulse.ts:81-87) carries no
// severity field to distinguish the two, and UX §4.2's own title ("calm, never alarming,
// always in words") makes the calmer tone the correct fail-safe default rather than
// guessing at `risk`. Icon+text always, never color alone (`.status-chip.warn` per §0's
// reuse list; `color-not-only` per `ui-ux-pro-max`; UX §4.6).
//
// Behind the `pulse.real_anomaly` fixture flag server-side (ADR-0023 decision 8, default
// OFF/fail-closed) - a flag-off state fires no `AnomalySignal`, so this component simply
// never renders rather than fabricating one (`PulseMetricCard` only renders it when an
// `anomaly` prop is actually supplied).
import type { AnomalySignal } from "@nightcrew/shared";

export const PulseAnomalyCallout = ({
  signal,
}: {
  readonly signal: AnomalySignal;
}): React.JSX.Element => (
  <p className="status-chip warn mt8" style={{ margin: "var(--space-5) 0 0" }}>
    <svg
      width="12"
      height="12"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2.5}
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="12" cy="12" r="9.5" />
      <path d="M12 7.5v6M12 16.8h.01" strokeLinecap="round" />
    </svg>
    {signal.summary}
  </p>
);
